var path = '/app/components/ui/level-bar/level-bar.html';
var html = "<div class=level-bar-container> <img ng-src={{$ctrl.renderCurrentType()}} /> <img ng-src={{$ctrl.renderCurrentLvl()}} /> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ui/level-bar/level-bar.html
// module id = 241
// module chunks = 0